import * as yup from "yup";

export function buildValidationSchema() {
  return yup.object().shape({
    restaurant: yup
      .string()
      .label("Restaurante")
      .required("Campo requerido"),
    prize: yup
      .string()
      .label("Premio")
      .required("Campo requerido"),
    start_date: yup
      .date()
      .required("Campo requerido"),
    end_date: yup
      .date()
      .required("Campo requerido"),
  });
}
